import { render, staticRenderFns } from "./CustomerContact.vue?vue&type=template&id=034c1df3&scoped=true"
import script from "./CustomerContact.vue?vue&type=script&lang=js"
export * from "./CustomerContact.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CustomerContact.vue?vue&type=style&index=1&id=034c1df3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c1df3",
  null
  
)

export default component.exports